import { Component, Input, Output, EventEmitter, OnInit, ViewChildren, QueryList, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
	selector: "app-otp-input",
	imports: [CommonModule],
	templateUrl: "./otp-input.component.html"
})
export class OtpInputComponent implements OnInit {
	@Input() length: number = 6;
	@Output() otpChange = new EventEmitter<string>();
	@Output() otpComplete = new EventEmitter<string>();
	@ViewChildren("otpInput") inputElements: QueryList<ElementRef>;

	otp: string[] = [];
	inputs: any[] = [];

	ngOnInit(): void {
		this.inputs = new Array(this.length);
		this.otp = new Array(this.length).fill("");
	}

	onInput(event: any, index: number): void {
		const input = event.target as HTMLInputElement;
		let value = input.value;

		if (value.length > 1) {
			value = value.substring(0, 1);
		}

		if (!/^[0-9]*$/.test(value)) {
			input.value = this.otp[index] || "";
			return;
		}

		this.otp[index] = value;
		input.value = value;

		this.emitOtp();

		if (value && index < this.length - 1) {
			this.focusNextInput(index);
		} else if (value && index === this.length - 1) {
			this.checkOtpCompletion();
		}
	}

	onKeyDown(event: KeyboardEvent, index: number): void {
		const input = event.target as HTMLInputElement;

		if (event.key === "Backspace") {
			if (!this.otp[index] && index > 0) {
				this.focusPreviousInput(index);
			} else {
				this.otp[index] = "";
				this.emitOtp();
			}
		} else if (event.key === "ArrowLeft" && index > 0) {
			this.focusPreviousInput(index);
		} else if (event.key === "ArrowRight" && index < this.length - 1) {
			this.focusNextInput(index);
		}
	}

	focusNextInput(index: number): void {
		if (index < this.length - 1) {
			this.inputElements?.toArray()[index + 1]?.nativeElement.focus();
		}
	}

	focusPreviousInput(index: number): void {
		if (index > 0) {
			this.inputElements?.toArray()[index - 1]?.nativeElement.focus();
		}
	}

	onPaste(event: ClipboardEvent, startIndex: number): void {
		event.preventDefault();
		const pastedData = event.clipboardData?.getData("text").trim();

		if (pastedData && /^[0-9]+$/.test(pastedData)) {
			const digits = pastedData.split("");
			let currentInputIndex = startIndex;

			for (const digit of digits) {
				if (currentInputIndex < this.length) {
					this.otp[currentInputIndex] = digit;
					const inputEl = this.inputElements.toArray()[currentInputIndex].nativeElement as HTMLInputElement;
					inputEl.value = digit;
					currentInputIndex++;
				} else {
					break;
				}
			}

			this.emitOtp();

			if (currentInputIndex < this.length) {
				this.inputElements.toArray()[currentInputIndex].nativeElement.focus();
			} else {
				this.inputElements.toArray()[this.length - 1].nativeElement.focus();
			}
			this.checkOtpCompletion();
		}
	}

	emitOtp(): void {
		const otpString = this.otp.join("");
		this.otpChange.emit(otpString);
	}

	checkOtpCompletion(): void {
		if (this.otp.every((digit) => digit !== "")) {
			const otpString = this.otp.join("");
			this.otpComplete.emit(otpString);
		}
	}

	clear(): void {
		this.otp = new Array(this.length).fill("");
		this.inputElements.forEach((el) => (el.nativeElement.value = ""));
		this.emitOtp();
		this.inputElements?.first?.nativeElement.focus();
	}

	setValue(value: string): void {
		if (value && value.length <= this.length && /^[0-9]+$/.test(value)) {
			this.clear();
			const digits = value.split("");
			digits.forEach((digit, index) => {
				this.otp[index] = digit;
				(this.inputElements.toArray()[index].nativeElement as HTMLInputElement).value = digit;
			});
			this.emitOtp();
			this.checkOtpCompletion();
			const nextFocusIndex = value.length < this.length ? value.length : this.length - 1;
			this.inputElements.toArray()[nextFocusIndex]?.nativeElement.focus();
		}
	}
}
